import { render, staticRenderFns } from "./InstagramInstantwinCampaignAnalyticsDialog.vue?vue&type=template&id=55d64744&scoped=true"
import script from "./InstagramInstantwinCampaignAnalyticsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinCampaignAnalyticsDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramInstantwinCampaignAnalyticsDialog.vue?vue&type=style&index=0&id=55d64744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d64744",
  null
  
)

export default component.exports